import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/admin';
import { useLocation } from 'react-router-dom';
import Breadcrumbs from '../../../components/elements/Breadcrumbs';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getSearchConfig, postSearchConfig } from '../../../services/search';
import useLocalStorage from '../../../hooks/useUserData';
import SearchSection from '../../../components/fragments/SearchSection';
import { showNotification } from '../../../utilities/mantineNotification';

const DetailSearchPage = (props) => {
  const [userData, setUserData] = useLocalStorage('persist:root', null);
  const [dataSearch, setDataSearch] = useState([]);
  const data = JSON.parse(userData?.auth);
  const location = useLocation();

  const queryParams: any = new URLSearchParams(location.search);

  const querytype = queryParams.get('type');
  const querysearch = queryParams.get('search');

  useEffect(() => {
    if (querysearch === '' || querysearch === null) {
      // go to home
      props.history.push('/search');
    } else {
    }
  }, [querysearch]);

  const [dataPayload, setDataPayload] = useState({
    type: querytype.toLowerCase(),
    limit: 0,
    isUmum: 'N',
    course: {
      search: querysearch.toLowerCase()
    },
    content: {
      search: querysearch.toLowerCase(),
      category: null
    },
    personalwisdom: {
      search: querysearch.toLowerCase()
    },
    leaderwisdom: {
      search: querysearch.toLowerCase()
    },
    fns: {
      search: querysearch.toLowerCase()
    },
    testimony: {
      search: querysearch.toLowerCase()
    }
  });

  useEffect(() => {
    const dataTemp = {
      type: querytype.toLowerCase(),
      limit: 0,
      isUmum: 'N',
      course: {
        search: querysearch.toLowerCase()
      },
      content: {
        search: querysearch.toLowerCase(),
        category: null
      },
      personalwisdom: {
        search: querysearch.toLowerCase()
      },
      leaderwisdom: {
        search: querysearch.toLowerCase()
      },
      fns: {
        search: querysearch.toLowerCase()
      },
      testimony: {
        search: querysearch.toLowerCase()
      }
    };
    setDataPayload(dataTemp);
  }, [querysearch]);

  useEffect(() => {
    fetchedSearchConfig.mutate(dataPayload);
  }, [dataPayload]);

  const fetchedSearchConfig = useMutation({
    mutationFn: postSearchConfig,
    onSuccess: () => {
      // console.log(data);
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  return (
    <AdminLayout>
      {/* <Breadcrumbs
        pageTitle={`Viewing all ${
          querytype === '001'
            ? 'Contents'
            : querytype === '006'
            ? 'Courses'
            : querytype === '003'
            ? 'Personal Wisdom'
            : querytype === '002'
            ? 'Leader Wisdom'
            : 'Testimony'
        }`}
        itemList={[]}
      /> */}

      <SearchSection
        pageSection={fetchedSearchConfig?.data?.data?.pageSection || []}
        loading={fetchedSearchConfig.isLoading}
        isError={fetchedSearchConfig.isError}
        isDetail={true}
      />
    </AdminLayout>
  );
};

export default DetailSearchPage;
